import * as React from 'react'

import { baseIntegrationImgSrc, circleCheckImg } from '../../shared'
import IntegrationTip from '../integration_tip'
import { getPageTitle } from '../../../Shared'

const classlinkIconSrc = `${window.postbuildEnv.CDN_URL}/images/shared/classlink_icon_lg.png`

const ClasslinkIntegrationContainer = () => {
  document.title = getPageTitle("Premium Hub", "Integrations | ClassLink")
  return (
    <div className="container">
      <section aria-labelledby="classlinkIntegrationContainerTitle" className="integration-container">
        <img alt="" className="logo" src={classlinkIconSrc} />
        <h2 id="classlinkIntegrationContainerTitle">Streamline teaching with ClassLink</h2>
        <p>Make teaching at your school even more effective with our seamless ClassLink integration. With this integration, teachers at your school or district can:</p>
        <ul>
          <li>{circleCheckImg}Seamlessly import ClassLink rosters.</li>
          <li>{circleCheckImg}Automatically create and sync ClassLink student accounts.</li>
        </ul>
        <div className="links">
          <a className="focus-on-light" href="https://support.quill.org/en/articles/8500172-how-do-i-select-a-rostering-integration-for-my-school-district" rel="noopener noreferrer" target="_blank">How to choose your integration</a>
          <a className="focus-on-light" href="https://support.quill.org/en/articles/11321582-how-do-i-set-up-a-classlink-rostering-integration-for-my-school-district-for-classlink-quill-administrators" rel="noopener noreferrer" target="_blank">How to set up this integration</a>
        </div>
        <IntegrationTip />
      </section>
    </div>
  )

}

export default ClasslinkIntegrationContainer
